import { render, staticRenderFns } from "./AuthenticationFormComponent.vue?vue&type=template&id=f462ddb2"
import script from "./AuthenticationFormComponent.vue?vue&type=script&lang=js"
export * from "./AuthenticationFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports